import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { DataTag } from "../../../../components/MediaFactory";

export default function DraggableDataTag({ tag }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: tag.id,
      data: tag,
    });

  const left = `${tag.position?.x ?? 50}%`;
  const top = `${tag.position?.y ?? 50}%`;

  const wrapperStyle = {
    position: "absolute",
    left,
    top,
    zIndex: isDragging ? 50 : 10,
    ...(transform
      ? { transform: `translate(${transform.x}px, ${transform.y}px)` }
      : {}),
  };

  return (
    <div ref={setNodeRef} style={wrapperStyle} {...listeners} {...attributes}>
      <DataTag
        label={tag.label}
        value="---"
        position={{ x: 0, y: 0 }}
        style={tag.style}
        isEditing={false}
      />
    </div>
  );
}
